import { Controller } from "@hotwired/stimulus"
import "emoji-picker-element"

// Connects to data-controller="badge-preview"
export default class extends Controller {
  static targets = ["preview", "emoji", "color", "description", "name"]

  connect() {
    this.updatePreview()
    // Create the emoji picker when needed
    this.picker = null
  }

  updatePreview() {
    const emoji = this.emojiTarget.value || "🏆"
    const color = this.colorTarget.value || "sunshine" 
    const description = this.descriptionTarget.value || ""
    const name = this.nameTarget.value || ""
    
    // Make AJAX request to render the badge using the partial
    const formData = new FormData()
    formData.append('emoji', emoji)
    formData.append('color', color)
    formData.append('name', name)
    formData.append('description', description)
    
    // Get CSRF token
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    
    fetch('/administration/badges/preview', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': token,
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
    .then(response => response.text())
    .then(html => {
      this.previewTarget.innerHTML = html
    })
    .catch(error => {
      console.error('Error updating badge preview:', error)
      // Fallback to simple text display
      this.previewTarget.innerHTML = `<div class="text-center p-4">${emoji} Preview Error</div>`
    })
  }

  showEmojiPicker(event) {
    const input = event.target
    
    if (!this.picker) {
      this.picker = document.createElement('emoji-picker')
      
      // Set theme based on document class
      if (document.documentElement.classList.contains('dark')) {
        this.picker.classList.add('dark')
      }
      
      // Find the closest container - try different possible parent containers
      const container = input.closest('.modal-box') || 
                       input.closest('.card-body') || 
                       input.closest('.form-control') ||
                       input.closest('div')
      
      if (!container) {
        console.error('No suitable container found for emoji picker')
        return
      }
      
      // Add to document body first with invisible positioning
      this.picker.style.position = 'fixed'
      this.picker.style.visibility = 'hidden'
      document.body.appendChild(this.picker)
      
      // Wait for Shadow DOM to be initialized
      requestAnimationFrame(() => {
        // Get dimensions after Shadow DOM is ready
        const pickerHeight = this.picker.getBoundingClientRect().height
        const pickerWidth = this.picker.getBoundingClientRect().width
        
        // Calculate available space
        const rect = input.getBoundingClientRect()
        const containerRect = container.getBoundingClientRect()
        const spaceBelow = window.innerHeight - rect.bottom
        const spaceAbove = rect.top
        const spaceRight = window.innerWidth - rect.left
        
        // Remove from body and add to container with proper positioning
        document.body.removeChild(this.picker)
        this.picker.style.position = 'absolute'
        this.picker.style.visibility = 'visible'
        container.appendChild(this.picker)
        
        // Position above or below based on available space
        if (spaceBelow < pickerHeight && spaceAbove > spaceBelow) {
          // Position above if more space there
          this.picker.style.top = `${rect.top - containerRect.top - pickerHeight - 5}px`
        } else {
          // Position below
          this.picker.style.top = `${rect.bottom - containerRect.top + 5}px`
        }
        
        // Position horizontally
        if (spaceRight < pickerWidth) {
          // Align right edge with input right edge
          this.picker.style.left = `${rect.right - containerRect.left - pickerWidth}px`
        } else {
          // Align left edge with input left edge
          this.picker.style.left = `${rect.left - containerRect.left}px`
        }
      })
      
      // Handle emoji selection
      this.picker.addEventListener('emoji-click', e => {
        input.value = e.detail.unicode
        this.updatePreview() // Update badge preview when emoji changes
        this.picker.remove()
        this.picker = null
      })
      
      // Handle click outside
      const closeHandler = (e) => {
        // Only proceed if picker still exists
        if (this.picker && !this.picker.contains(e.target) && e.target !== input) {
          this.picker.remove()
          this.picker = null
          document.removeEventListener('click', closeHandler)
        }
      }
      setTimeout(() => document.addEventListener('click', closeHandler), 0)
    } else {
      this.picker.remove()
      this.picker = null
    }
  }
} 